import { newBigIntId } from 'src/utils/idUtils';
import { posChangedField, posField } from 'src/utils/posFieldUtils';
import { PurchaseOrderDetailsInput } from 'src/utils/purchaseUtils';
import {
  DeliveryType,
  LoginContext,
  TicketGroupInput,
} from 'src/WebApiController';

export const createDefaultPoValues = ({
  activeAccountUserId,
  loginContext,
}: {
  activeAccountUserId?: string | null;
  loginContext?: LoginContext | null;
}) => {
  return {
    id: newBigIntId(),
    buyerUserId: posChangedField(activeAccountUserId),
    purchaseDate: posChangedField(new Date().toISOString()),
    currencyCode: posChangedField(
      loginContext?.user?.activeAccount?.currencyCode
    ),
    ticketGroupIntentions: {},
    ticketGroups: [],
    deal: null,
  } as unknown as PurchaseOrderDetailsInput;
};

export const createNewPoValues = ({
  activeAccountUserId,
  loginContext,
  prevTicketGroup,
}: {
  activeAccountUserId?: string | null;
  loginContext?: LoginContext | null;
  prevTicketGroup: TicketGroupInput | null;
}) => {
  const defaultPo = createDefaultPoValues({
    activeAccountUserId,
    loginContext,
  });

  if (!prevTicketGroup) {
    return defaultPo;
  }

  const startId = newBigIntId();
  const { event, performer, venue } = prevTicketGroup;

  const currencyCode =
    prevTicketGroup.currencyCode?.value ??
    loginContext?.user?.activeAccount?.currencyCode ??
    'USD';

  defaultPo.ticketGroups = [
    {
      ticketGroupId: startId,
      deliveryType: posChangedField(DeliveryType.InApp),
      currencyCode: posChangedField(currencyCode),
      viagogoVirtualId: event?.virtId,
      eventMappingId: event?.mpId,
      viagogoEventId: event?.viagId,
      posEventId: event?.posId,
      event: event,
      expectedValue: posChangedField(null),
      faceValueCost: posField(null),
      row: posChangedField(null),
      section: posChangedField(null),
      listingNotes: posChangedField(null),
      numberOfTickets: posChangedField(null),
      unitCost: posChangedField(null),
      totalCost: posChangedField(null),
      performer: performer,
      venue: venue,
      taxPaid: posChangedField(1), // This is to turn off taxExempt by default
    } as TicketGroupInput,
  ];
  return defaultPo;
};
